var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
// import {customElement, property, queryAssignedElements} from 'lit/decorators.js';
import { property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './sds-header.lit.scss';
import stylesGlobal from './_sds-header-global.lit.scss';
import { appendStylesToTheStyleRoot } from '../utilities/dom';
import '../utilities/window-size';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * Represents a header component, providing a flexible way to include icons, titles, labels, breadcrumbs, and actions.
 *
 * ## Slots
 *
 * - `icon`: Used to pass an icon component that will be placed in the header.
 * - `back`: Used for passing a back button component, typically used for navigation purposes.
 * - `title`: Slot to pass the main title content of the header.
 * - `label`: Slot for providing additional label information next to the title.
 * - `breadcrumbs`: Slot for adding breadcrumb navigation links.
 * - `actions`: Slot for adding action items or buttons, typically placed on the right side of the header.
 *
 * ## Events
 *
 * The `SdsHeader` component emits the following custom events:
 *
 * - `sds.sidebar.action`: Dispatched when the sidebar action button (hamburger menu) is clicked. It is used to toggle the visibility of a sidebar or navigation drawer.
 * - `sds.search.changed`: Emitted when the search input value changes. The detail of the event contains the current value of the search input.
 * - `sds.search.cleared`: Dispatched when the search input is cleared. This event is useful for resetting search-related functionality or content when the search input is cleared.
 *
 * @csspart sds-header - The CSS part name for styling the header component.
 * @csspart sds-main-header-search - The CSS part name for styling the search input.
 * @csspart sds-main-header-search-close-action
 *
 * @fires sds.sidebar.action - Event emitted when the sidebar action button is clicked.
 * @fires sds.search.changed - Event emitted with the detail of the current search value when it changes.
 * @fires sds.search.cleared - Event emitted when the search input is cleared.
 */
let SdsHeader = (() => {
    var _SdsHeader_mainHeader_accessor_storage, _SdsHeader_withSearch_accessor_storage, _SdsHeader_isChild_accessor_storage, _SdsHeader__noIcon_accessor_storage, _SdsHeader__navigationExpanded_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-header')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _mainHeader_decorators;
    let _mainHeader_initializers = [];
    let _mainHeader_extraInitializers = [];
    let _withSearch_decorators;
    let _withSearch_initializers = [];
    let _withSearch_extraInitializers = [];
    let _isChild_decorators;
    let _isChild_initializers = [];
    let _isChild_extraInitializers = [];
    let __noIcon_decorators;
    let __noIcon_initializers = [];
    let __noIcon_extraInitializers = [];
    let __navigationExpanded_decorators;
    let __navigationExpanded_initializers = [];
    let __navigationExpanded_extraInitializers = [];
    var SdsHeader = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this._stylesGlobal = stylesGlobal;
            _SdsHeader_mainHeader_accessor_storage.set(this, __runInitializers(this, _mainHeader_initializers, false));
            _SdsHeader_withSearch_accessor_storage.set(this, (__runInitializers(this, _mainHeader_extraInitializers), __runInitializers(this, _withSearch_initializers, false)));
            _SdsHeader_isChild_accessor_storage.set(this, (__runInitializers(this, _withSearch_extraInitializers), __runInitializers(this, _isChild_initializers, false)));
            _SdsHeader__noIcon_accessor_storage.set(this, (__runInitializers(this, _isChild_extraInitializers), __runInitializers(this, __noIcon_initializers, true)));
            _SdsHeader__navigationExpanded_accessor_storage.set(this, (__runInitializers(this, __noIcon_extraInitializers), __runInitializers(this, __navigationExpanded_initializers, false)));
            this._handleSlotChange = (__runInitializers(this, __navigationExpanded_extraInitializers), (e) => {
                const slot = e.target;
                const nodes = slot.assignedNodes({ flatten: true });
                this._noIcon =
                    nodes.length === 0 ||
                        nodes.every(n => { var _a; return n.nodeType === Node.TEXT_NODE && !((_a = n.textContent) === null || _a === void 0 ? void 0 : _a.trim()); });
            });
            this.handleSearchEvent = (event) => {
                const searchValue = event.detail.value;
                const searchEvent = new CustomEvent(SdsHeader.SEARCH_CHANGED_EVENT, {
                    detail: { value: searchValue },
                    bubbles: true,
                    composed: true,
                });
                this.dispatchEvent(searchEvent);
            };
            this.handleSearchClearedEvent = (event) => {
                const searchValue = event.detail.value;
                const searchEvent = new CustomEvent(SdsHeader.SEARCH_CLEARED_EVENT, {
                    detail: { value: searchValue },
                    bubbles: true,
                    composed: true,
                });
                this.dispatchEvent(searchEvent);
            };
            this.handleSearchOpenClick = () => {
                var _a, _b;
                const searchElementContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-main-header__search');
                const searchElement = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.sds-main-header__search-element');
                if (searchElementContainer && searchElement) {
                    searchElementContainer.classList.add('sds-main-header__search--opened');
                    searchElement.setAttribute('focused', '');
                }
            };
            this.handleSearchCloseClick = () => {
                var _a;
                const searchElementContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-main-header__search');
                if (searchElementContainer) {
                    searchElementContainer.classList.remove('sds-main-header__search--opened');
                }
            };
        }
        /**
         * Determines if this header should be styled as the main header.
         * When set to `true`, the component adopts primary header styling,
         * indicating its prominence within the application.
         *
         * @attr {boolean} main-header - Styles the header as the main header.
         */
        get mainHeader() { return __classPrivateFieldGet(this, _SdsHeader_mainHeader_accessor_storage, "f"); }
        set mainHeader(value) { __classPrivateFieldSet(this, _SdsHeader_mainHeader_accessor_storage, value, "f"); }
        /**
         * Specifies whether a search bar should be included in the header.
         * When `true`, a search input is displayed, allowing users to perform searches directly from the header.
         *
         * @attr {boolean} with-search - Displays a search bar within the header.
         */
        get withSearch() { return __classPrivateFieldGet(this, _SdsHeader_withSearch_accessor_storage, "f"); }
        set withSearch(value) { __classPrivateFieldSet(this, _SdsHeader_withSearch_accessor_storage, value, "f"); }
        /**
         * Indicates if this header is a child header, typically used for sub-views or sub-sections.
         * Setting this attribute to `true` applies styling suitable for secondary headers,
         * helping to visually differentiate it from main headers.
         *
         * @attr {boolean} is-child - Styles the header as a child or secondary header.
         */
        get isChild() { return __classPrivateFieldGet(this, _SdsHeader_isChild_accessor_storage, "f"); }
        set isChild(value) { __classPrivateFieldSet(this, _SdsHeader_isChild_accessor_storage, value, "f"); }
        get _noIcon() { return __classPrivateFieldGet(this, _SdsHeader__noIcon_accessor_storage, "f"); }
        set _noIcon(value) { __classPrivateFieldSet(this, _SdsHeader__noIcon_accessor_storage, value, "f"); }
        get _navigationExpanded() { return __classPrivateFieldGet(this, _SdsHeader__navigationExpanded_accessor_storage, "f"); }
        set _navigationExpanded(value) { __classPrivateFieldSet(this, _SdsHeader__navigationExpanded_accessor_storage, value, "f"); }
        render() {
            if (this.mainHeader) {
                appendStylesToTheStyleRoot(this, 'sds-header', this._stylesGlobal.cssText);
                return html ` ${this.renderMainHeader()} `;
            }
            else {
                return html ` ${this.renderLayoutHeader()} `;
            }
        }
        renderMainHeader() {
            return html `
            <div class="sds-main-header">
                ${this.renderSidebarAction()} ${this.renderMainHeaderLogo()} ${this.renderSearch()}
                ${this.renderMainHeaderActions()}
            </div>
        `;
        }
        renderLayoutHeader() {
            return html `
            <div class="${this.getClasses()}" part="sds-header">
                <div class="sds-header__section">
                    <div class="sds-header__icon ${this._noIcon ? 'sds-header__icon-hidden' : ''}">
                        <slot name="back" @slotchange=${this._handleSlotChange}></slot>
                        <slot name="icon" @slotchange=${this._handleSlotChange}></slot>
                    </div>
                    <div class="sds-header__title-container">
                        <div class="sds-header__title">
                            <slot name="title"></slot>
                        </div>
                        <div class="sds-header__label">
                            <slot name="label"></slot>
                        </div>
                    </div>
                    <div class="sds-header__info">
                        <slot name="breadcrumbs"></slot>
                    </div>
                </div>
                <div class="sds-header__actions">
                    <slot name="actions"></slot>
                </div>
            </div>
        `;
        }
        renderSidebarAction() {
            return html `
            <sds-button
                class="sds-main-header__hamburger"
                @click="${() => this.handleSidebarActionClick()}"
                icon="burger"
                type="primary"
                size="lg"
                aria-label="Toggle navigation menu"
                aria-expanded="${this._navigationExpanded}"
                aria-controls="navigation-sidebar"
            ></sds-button>
            <div id="navigation-status" class="sr-only" aria-live="polite" aria-atomic="true"></div>
        `;
        }
        renderMainHeaderLogo() {
            return html ` <slot name="logo"></slot> `;
        }
        renderSearch() {
            return html ` <slot name="container"></slot> `;
        }
        renderSearchResponsiveButton() {
            if (this.withSearch) {
                return html `
                <sds-button
                    class="sds-main-header__search--responsive"
                    part="sds-main-header-search-responsive"
                    @click=${this.handleSearchOpenClick}
                    slot="action"
                    type="primary"
                    size="lg"
                    icon="search"
                ></sds-button>
            `;
            }
        }
        renderMainHeaderActions() {
            return html `
            <div class="sds-main-header__actions">
                ${this.renderSearchResponsiveButton()}
                <slot name="action"></slot>
            </div>
        `;
        }
        handleSidebarActionClick() {
            var _a;
            // Toggle the navigation state
            this._navigationExpanded = !this._navigationExpanded;
            // Update aria-label with current state
            const button = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-main-header__hamburger');
            if (button) {
                const stateText = this._navigationExpanded ? 'folded' : 'unfolded';
                button.setAttribute('aria-label', `Toggle navigation menu, currently ${stateText}`);
            }
            // Announce the state change
            this.announceNavigationState();
            const event = new CustomEvent(SdsHeader.SIDEBAR_TOGGLE_EVENT, {
                bubbles: true,
                composed: true,
            });
            this.dispatchEvent(event);
        }
        /**
         * Announces navigation state changes to screen readers
         */
        announceNavigationState() {
            var _a;
            const statusElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#navigation-status');
            if (statusElement) {
                statusElement.textContent = this._navigationExpanded
                    ? 'Navigation folded'
                    : 'Navigation unfolded';
                // Clear the announcement after a short delay to prepare for next announcement
                setTimeout(() => {
                    statusElement.textContent = '';
                }, 1000);
            }
        }
        getClasses() {
            return classMap({
                'sds-header': true,
                'sds-header--second-level': this.isChild,
            });
        }
    };
    _SdsHeader_mainHeader_accessor_storage = new WeakMap();
    _SdsHeader_withSearch_accessor_storage = new WeakMap();
    _SdsHeader_isChild_accessor_storage = new WeakMap();
    _SdsHeader__noIcon_accessor_storage = new WeakMap();
    _SdsHeader__navigationExpanded_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsHeader");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _mainHeader_decorators = [property({ type: Boolean, attribute: 'main-header' })];
        _withSearch_decorators = [property({ type: Boolean, attribute: 'with-search' })];
        _isChild_decorators = [property({ type: Boolean, attribute: 'is-child' })];
        __noIcon_decorators = [state()];
        __navigationExpanded_decorators = [state()];
        __esDecorate(_classThis, null, _mainHeader_decorators, { kind: "accessor", name: "mainHeader", static: false, private: false, access: { has: obj => "mainHeader" in obj, get: obj => obj.mainHeader, set: (obj, value) => { obj.mainHeader = value; } }, metadata: _metadata }, _mainHeader_initializers, _mainHeader_extraInitializers);
        __esDecorate(_classThis, null, _withSearch_decorators, { kind: "accessor", name: "withSearch", static: false, private: false, access: { has: obj => "withSearch" in obj, get: obj => obj.withSearch, set: (obj, value) => { obj.withSearch = value; } }, metadata: _metadata }, _withSearch_initializers, _withSearch_extraInitializers);
        __esDecorate(_classThis, null, _isChild_decorators, { kind: "accessor", name: "isChild", static: false, private: false, access: { has: obj => "isChild" in obj, get: obj => obj.isChild, set: (obj, value) => { obj.isChild = value; } }, metadata: _metadata }, _isChild_initializers, _isChild_extraInitializers);
        __esDecorate(_classThis, null, __noIcon_decorators, { kind: "accessor", name: "_noIcon", static: false, private: false, access: { has: obj => "_noIcon" in obj, get: obj => obj._noIcon, set: (obj, value) => { obj._noIcon = value; } }, metadata: _metadata }, __noIcon_initializers, __noIcon_extraInitializers);
        __esDecorate(_classThis, null, __navigationExpanded_decorators, { kind: "accessor", name: "_navigationExpanded", static: false, private: false, access: { has: obj => "_navigationExpanded" in obj, get: obj => obj._navigationExpanded, set: (obj, value) => { obj._navigationExpanded = value; } }, metadata: _metadata }, __navigationExpanded_initializers, __navigationExpanded_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsHeader = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.SIDEBAR_TOGGLE_EVENT = 'sds.sidebar.action';
    _classThis.SEARCH_CHANGED_EVENT = 'sds.search.changed';
    _classThis.SEARCH_CLEARED_EVENT = 'sds.search.cleared';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsHeader = _classThis;
})();
export { SdsHeader };
